import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {UserListService} from './user-list.service';
import {UserListPagerService} from './pager.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {ActivateService} from '../activate/activate.service';
import {NotifierService} from "../notifier/notifier.service";
import {NotificationType} from "../notifier/notification-type.enum";
import {CommonService} from "../../common/common.service";
import {Dictionary} from "../../model/dictionary";
import {Group} from "../../model/group";
import {GroupCreateService} from "../group-create/group-create.service";
import {FormMode} from "../group-create/form-mode.enum";
import {CreateGroupStep} from "../group-create/create-group-step.enum";
import {User} from "../../model/user";
import {HeaderService} from "../header/header.service";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {ActivatedRoute} from "@angular/router";
import {NgbDate} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "pbc-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.scss"]
})
export class UserListComponent implements OnInit {

  userData: any[];

  pager: any = {};

  pagedItems: Array<User> = [];

  unblockUserPopupFlag: boolean = false;

  blockUserPopupFlag: boolean = false;

  addUserPopupFlag: boolean = false;

  userToBlockUnblock: any;

  userTOBlockedTill: any;

  userId: string;

  blockedTill: string;

  newUserForm: FormGroup;

  submitted: boolean = false;

  dateInputFlag: boolean = false;

  groupSelectedList: Array<number> = [];

  setSelectedList: Array<number> = [];

  blockedTillDate: any;

  isDelete: boolean;

  selectedUsers: Array<User> = [];

  selectedUserGroups: Array<number> = [];

  deletedUsersCount: number;

  headerChecked: boolean;

  showDeleteUserPopup: boolean;
  showDeleteUsersPopup: boolean;

  addingToGroup: boolean;

  createNewGroup: boolean;

  selfRegister: boolean;

  assignUsersFromGroup: boolean;

  usersSelectedGroups: Array<any> = [];

  selectedUserIds: Array<any> = [];

  userToOperateOn : User;


  //Limity do rozwijania list checkboxow
  private readonly MORE_LESS_LIMIT : number = 6;

  private groupList: any[];

  items: number[] = [1];

  domainNameErrorArray: Array<any> = [];

  groupSubmitted: boolean = false;

  userSubmitted: boolean = false;

  isEditUser: boolean;

  filter: boolean;

  domainName: any[];

  domainNameSelected: Array<any> = [];

  userGroup: any[];

  dictInterestArea: any[];

  dictInterestAreaSelected: Array<any> = [];

  filterObj = {};

  filteredUsersCount : number = 0;

  dateFromFilter: NgbDateStruct;
  dateToFilter: NgbDateStruct;
  dateFrom: Date;
  dateTo: Date;

  //Sortowania
  orderByField : string = "lastName";
  orderAsc : boolean =  true;
  usersAreFiltered : boolean = false;

  //Filtry
  private userGroups : Array<Group> = [];
  private userDomains : Array<string> = [];
  private userGroupsForFilterSelected : Array<string> = [];
  private userDomainsForFilterSelected : Array<string> = [];

  private notificationFrequencies : Array<Dictionary> = [];
  private userNotificationFrequenciesForFilterSelected : Array<string> = [];

  private areas : Array<Dictionary> = [];
  private interestAreasForFilterSelected : Array<string> = [];
  private userAreasForFilterSelected : Array<string> = [];

  private positions : Array<Dictionary> = [];
  private userPositionsForFilterSelected : Array<string> = [];

  private clientGroups : Array<Dictionary> = [];
  private interestClientGroupsForFilterSeleted : Array<string> = [];

  private institutions : Array<Dictionary> = [];
  private interestInstitutionsForFilterSelected : Array<string> = [];

  private products : Array<Dictionary> = [];
  private interestProductsForFilterSelected : Array<string> = [];

  private userActiveStatus = ['Aktywowany', 'Nieaktywowany'];
  private userActiveStatusSelected : Array<string> =[];
  private userBlockStatus = ['Zablokowany', 'Niezablokowany'];
  private userBlockStatusSelected : Array<string> = [];
  private userTypes = ['Administrator', 'Użytkownik końcowy'];
  private userTypeSelected : Array<string> = [];
  private marketingAgreements = ['Zgoda marketingowa', 'Brak zgody marketingowej'];
  private marketingAgreementSelected : Array<string> = [];

  private static pageSize: number = 20;
  private currentPage : number = 1;

  @ViewChildren("domainNameData") domainNameData: QueryList<ElementRef>;
  @ViewChildren("userGrp") clientGrp: QueryList<ElementRef>;
  @ViewChildren("intrstArea") intrstArea: QueryList<ElementRef>;

  constructor(
    private notifierService : NotifierService,
    private commonService : CommonService,
    private userListService: UserListService,
    private pagerService: UserListPagerService,
    private _formBuilder: FormBuilder,
    private activateService: ActivateService,
    private headerService : HeaderService,
    private groupCreateService: GroupCreateService,
    private breadCrumbsService : BreadcumbsService,
    private activatedRoute : ActivatedRoute
  ) { }

  ngOnInit() {
    this.headerService.hideLoginRegisterButtons();
    setTimeout(()=>this.breadCrumbsService.setSubfolder.emit("Użytkownicy"),100);

    this.getDictionaries();
    this.submitted = false;
    this.iterate();
    this.newUserForm = this.createUserForm();

    this.activateService.getDictInterestArea().subscribe(res => {
      this.dictInterestArea = res;
    });

    this.userListService.getListOfUniqueDomains().subscribe(res => {
      this.domainName = res.record;
    });

    this.groupCreateService.groupAddedOrModified.subscribe((result : boolean) => {
      if (result)
        this.selectedUsers = [];
        this.selectedUserIds = [];
        this.headerChecked = false;
    })

    this.activatedRoute.params.subscribe(
      queryParams => {
        const refresh = queryParams['refresh'];
        if (refresh > 0)
          this.clearForm();
      }
    )
  }

  createUserForm(): FormGroup {
    return this._formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    })
  }

  setPage(page: number) {
    // get pager object from service
    this.pager = this.pagerService.getPager(this.userData.length, page, UserListComponent.pageSize);
    this.currentPage = page;

    // get current page of items
    this.pagedItems = this.userData.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  filterWithDateFrom() : void {
    const dateFrom = this.dateFromFilter ? new Date(this.dateFromFilter.year, this.dateFromFilter.month - 1, this.dateFromFilter.day).toUTCString() : null;
    if (dateFrom) {
      this.filterObj['dateFrom'] = dateFrom;
      this.getFilteredUserList(false);
    }
  }

  filterWithDateTo() : void {
    const dateTo = this.dateToFilter ? new Date(this.dateToFilter.year, this.dateToFilter.month - 1, this.dateToFilter.day).toUTCString() : null;
    if (dateTo) {
      this.filterObj['dateTo'] = dateTo;
      this.getFilteredUserList(false);
    }
  }


  unblockUserPopup(user: any): void {
    this.blockUserPopupFlag = false;
    this.userId = user.id;
    this.unblockUserPopupFlag = true;
    this.userToBlockUnblock = user.firstName + " " + user.lastName;
    this.userTOBlockedTill = user.blockedTill;
  }

  private sendActivationEmail(email : string) {
    this.commonService.sendActivationEmail(email).subscribe(
      result=>{
        if (result.status==1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Wysłano mail aktywacyjny do: ".concat(email));
        else {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie wysłano maila aktywacyjnego do: ".concat(email));
          console.log("Admin: Nie wysłano maila aktywacyjnego: ".concat(result.message));
        }
      },
      error => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie wysłano maila aktywacyjnego do: ".concat(email));
        console.log("Admin: Nie wysłano maila aktywacyjnego: ".concat(error));
      }
    )
  }

  blockUserPopup(user: any): void {
    this.userId = user.id;
    this.blockUserPopupFlag = true;
    this.userToBlockUnblock = user.firstName + " " + user.lastName;
  }

  addUserPopup() {
    this.newUserForm = this.createUserForm();
    this.addUserPopupFlag = true;
  }

  hidePopup(): void {
    this.isEditUser = false;
    this.groupSelectedList = [];
    this.unblockUserPopupFlag = false;
    this.blockUserPopupFlag = false;
    this.addUserPopupFlag = false;
    this.submitted = false;
    this.blockedTillDate = null;
    this.showDeleteUserPopup = false;
    this.showDeleteUsersPopup = false;
    this.addingToGroup = false;
    this.selectedUserGroups = [];
    this.createNewGroup = false;
    this.userSubmitted = false;
    this.items = [1];
    this.filter = false;
  }

  unlockUser(): void {
    this.lockUnlockData('false');
  }

  lockUser(): void {
    if (this.blockedTill === '1') {
      if (this.blockedTillDate) {
        this.lockUnlockData('true');
      } else {
        this.dateInputFlag = true;
      }
    } else {
      this.lockUnlockData('true');
    }
    this.blockUserPopupFlag = false;
  }

  lockUnlockData(blocked: any): void {
    this.unblockUserPopupFlag = false;
    const lockUnlockObj = {};
    const userIds = [];
    userIds.push(this.userId);
    lockUnlockObj['id'] = userIds;
    lockUnlockObj['blocked'] = blocked;
    if (blocked === 'true') {
      const tillDate = this.blockedTillDate ? new Date(this.blockedTillDate.year, this.blockedTillDate.month - 1, this.blockedTillDate.day) : null;
      lockUnlockObj['blockedTill'] = this.blockedTill === '1' ? tillDate : null;
    }
    this.userListService.unlockUser(lockUnlockObj).subscribe((res) => {
      if (res.status == 1) {

        if (blocked == "true")
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Użytkownik ".concat(this.userToBlockUnblock, "został zablokowany"));
        else
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Użytkownik ".concat(this.userToBlockUnblock, " został odblokowany"));

        if (!this.usersAreFiltered)
          this.iterate(this.currentPage);
        else
          this.getFilteredUserList(true);

      } else {

        if (blocked == "true")
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystapił błąd! Użytkownik ".concat(this.userToBlockUnblock, " nie został zablokowany"));
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystapił błąd! Użytkownik ".concat(this.userToBlockUnblock, " nie został odblokowany"));

      }
    }, error => {

      if (blocked == true)
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystapił błąd! Użytkownik ".concat(this.userToBlockUnblock, " nie został zablokowany"));
      else
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystapił błąd! Użytkownik ".concat(this.userToBlockUnblock, " nie został odblokowany"));

      console.log("Error:", error);

    });
  }

  iterate(goToPage? : number): void {
    this.blockedTill = '0';
    this.userListService.getGroupList("name ASC").subscribe(res => {
      this.groupList = res.record;
    }, error => {
      console.log("Error:", error);
    }
    );
    this.userListService.getUsers({sortString : this.createSortString()}).subscribe(
      data => {
        this.userData = data["record"];
        this.filteredUsersCount = this.userData.length;
        this.userData = this.userData.map(res => {
          res.isOpen = false;
          return res;
        });
        if (goToPage > 0)
          this.setPage(goToPage);
        else
          this.setPage(1);
      },
      error => {
        console.log("Error:", error);
      }
    );
  }

  groupsSelected(event: any): void {
    if (event.target.checked) {
      this.groupSelectedList.push(Number(event.target.value));
    } else {
      this.groupSelectedList.splice(this.groupSelectedList.indexOf(Number(event.target.value)), 1);
    }
  }

  addUser(): void {
    this.userSubmitted = true;
    if (this.newUserForm.valid) {
      const userData = this.newUserForm.getRawValue();
      userData['groupIds'] = this.groupSelectedList;
      userData['isClient'] = true;
      userData['isAdmin'] = false;
      let email : string = this.newUserForm.controls['email'].value;
      this.commonService.userExists(email).subscribe(//Sprawdzam, czy user juz istnieje
          result => {
            if (result.status != 1)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Wystąpił błąd! Nie można sprawdzić, czy użytkownik o podanym adresie email istnieje");
            else {
              if (result.message)
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                    "Konto z podanym adresem email istnieje już w serwisie");
              else { //Jak nie istnieje, to dodaje
                this.userListService.createUser(userData).subscribe(
                    response => {
                      if (response.status === 'OK') {
                        this.hidePopup();
                        let firstNameCratedUser : string = response.record.firstName;
                        let lastNameCreatedser : string = response.record.lastName;
                        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                            "Użytkownik ".concat(firstNameCratedUser, " ", lastNameCreatedser," został poprawnie dodany do systemu."));

                        if (!this.usersAreFiltered)
                          this.iterate(this.currentPage);
                        else
                          this.getFilteredUserList(true);

                      } else {
                        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                            "Wystąpił błąd! Użytkownik ".concat(userData['firstName'], " ", userData['lastName'], " nie został poprawnie dodany do systemu. Spróbuj jeszcze raz."));
                      }
                    },
                    error => {
                      this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                          "Wystąpił błąd! Użytkownik ".concat(userData['firstName'], " ", userData['lastName'], " nie został poprawnie dodany do systemu. Spróbuj jeszcze raz."));
                      console.log("Error:", error);
                    }
                );
              }
            }
          },
          error => {
            console.log(error);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Nie można sprawdzić, czy użytkownik o podanym adresie email istnieje");
          }
      );
    }
  }

  selectedIdCount(checkedField: string, event: any, user: any): void {
    if (event.target.checked && checkedField === 'particularId') {
      this.isDelete = true;
      this.selectedUsers.push(user);
      this.selectedUserIds.push(user.id);
      this.deletedUsersCount = this.selectedUsers.length;
    } else if (event.target.checked && checkedField === 'headerCheckbox') {
      this.headerChecked = true;
      this.selectedUsers = [];
      this.isDelete = true;
      this.deletedUsersCount = this.userData.length;
      for (var i = 0; i < this.userData.length; i++) {
        this.selectedUsers.push(this.userData[i]);
        this.selectedUserIds.push(this.userData[i].id);
      }
    }
    else if (!event.target.checked && checkedField === 'headerCheckbox') {
      this.selectedUsers = [];
      this.selectedUserIds = [];
      this.isDelete = false;
      this.headerChecked = false;
    }
    else if (user) { // removes users from array while box is unchecked
      this.selectedUsers = this.selectedUsers.filter((item) => item.id !== user.id);
      this.selectedUserIds.splice(this.selectedUserIds.indexOf(user.id), 1);

      if (this.selectedUsers.length === 0) {
        this.isDelete = false;
      }
    }
    if (this.selectedUsers.length === 1) {
      this.selectedUserGroups = this.selectedUsers[0].groups.map((item: any) => item.id);
    }
    if (this.userData.length === this.selectedUsers.length) {
      this.headerChecked = true;
    }
    else {
      this.headerChecked = false;
    }
  }

  private deleteUser() {
    let userToDelete : Array<number> = [];
    userToDelete.push(this.userToOperateOn.id);
    let deletedUserFirstLastName : string = this.userToOperateOn.firstName.concat(" ", this.userToOperateOn.lastName);

    this.userListService.deleteUsers(userToDelete).subscribe(
      response=>{
        if (response.status == 1) {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Użytkownik ".concat(deletedUserFirstLastName, " został usunięty z systemu. Od tej chwili nie będzie mógł sie zalogować"));

          if (!this.usersAreFiltered)
            this.iterate(this.currentPage);
          else
            this.getFilteredUserList(true);

          if (this.selectedUsers.indexOf(this.userToOperateOn) != -1)
            this.selectedUsers.splice(this.selectedUsers.indexOf(this.userToOperateOn), 1);
        }
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Użytkownik ".concat(deletedUserFirstLastName, " nie zostali usunięci z systemu. Spróbuj jeszcze raz"));

        this.userToOperateOn = undefined;
        this.showDeleteUserPopup = false;
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Użytkownik ".concat(deletedUserFirstLastName, " nie zostali usunięci z systemu. Spróbuj jeszcze raz"));
        this.showDeleteUserPopup = false;
      }
    )
  }

  deleteUsers(): void {
    this.userListService.deleteUsers(this.selectedUsers.map((item) => item.id)).subscribe(response => {

      if (response.status == 1) {
        if (this.selectedUsers.length == 1) {
          let deletedUserFirstLastName : string = this.selectedUsers[0].firstName.concat(" ", this.selectedUsers[0].lastName);
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Użytkownik ".concat(deletedUserFirstLastName, " został usunięty z systemu. Od tej chwili nie będzie mógł sie zalogować"));
        } else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Użytkownicy (".concat(this.selectedUsers.length.toString(), ") zostali usunięci z systemu. Od tej chwili nie będą mogli sie zalogować"))
        }
      } else {
        if (this.selectedUsers.length == 1) {
          let deletedUserFirstLastName : string = this.selectedUsers[0].firstName.concat(" ", this.selectedUsers[0].lastName);
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wystąpił błąd! Użytkownik ".concat(deletedUserFirstLastName, " nie zostali usunięci z systemu. Spróbuj jeszcze raz"));
        } else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wystąpił błąd! Użytkownicy (".concat(this.selectedUsers.length.toString(), ") nie zostali usunięci z systemu. Spróbuj jeszcze raz"));
        }
      }
      this.selectedUsers = [];
      if (this.selectedUsers.length === 0) {
        this.isDelete = false;
      }
      this.showDeleteUsersPopup = false;

      if (!this.usersAreFiltered)
        this.iterate(this.currentPage);
      else
        this.getFilteredUserList(true);
    },
      error => {
        if (this.selectedUsers.length == 1) {
          let deletedUserFirstLastName : string = this.selectedUsers[0].firstName.concat(" ", this.selectedUsers[0].lastName);
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wystąpił błąd! Użytkownik ".concat(deletedUserFirstLastName, " nie został usunięty z systemu. Spróbuj jeszcze raz"));
        } else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wystąpił błąd! Użytkownicy (".concat(this.selectedUsers.length.toString(), ") nie zostali usunięci z systemu. Spróbuj jeszcze raz"));
        }
        console.log("Error:", error);
      });
  }

  assignUsersToGroup(): void {
    let requestArray = [];
    for (var i = 0; i < this.groupSelectedList.length; i++) {
      requestArray.push(this.userListService.assignUsersToGroup(this.selectedUsers.map((item) => item.id), this.groupSelectedList[i]));
    }
    forkJoin(requestArray).subscribe(results => {
      let requestsResult : boolean = true;
      results.forEach(result=>{
        // @ts-ignore
        if (result.status == 1)
          requestsResult = requestsResult && true;
        else
          requestsResult = requestsResult && false;
      });
      if (requestsResult) {

        if (!this.usersAreFiltered)
          this.iterate(this.currentPage);
        else
          this.getFilteredUserList(true);

        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
          "Zaznaczeni użytkownicy (".concat(this.selectedUsers.length.toString(), ") zostali dodani do wskazanych grup (", this.groupSelectedList.length.toString(), ")"));
      } else {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Zaznaczeni użytkownicy nie zostali dodani do wskazanych grup")
      }

      this.selectedUserIds = [];
      this.selectedUsers = [];
      this.isDelete = false;
      this.addingToGroup = false;
      this.groupSelectedList = [];
    },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Zaznaczeni użytkownicy nie zostali dodani do wskazanych grup")
      }
    )
  }

  createNewGroups(): void {
    this.groupCreateService.showForm(FormMode.CREATE, CreateGroupStep.Definition, undefined, this.selectedUsers);
  }

  uploadImage($event: any): void {
    if ($event.target.files && $event.target.files[0]) {
    }
  }

  copy(): void {
    this.items.push(this.items.length + 1);
  }

  domainNameValue(item: any, event: any): void {
    let domainValuesObject = {
      item: item,
      value: event.target.value
    };
    let index = this.domainNameErrorArray.findIndex(object => object.item === item);
    if (index !== -1 && event.target.value !== '') {
      this.domainNameErrorArray[index].value = event.target.value;
    } else if (index !== -1 && event.target.value === '') {
      this.domainNameErrorArray.splice(index, 1);
    } else {
      this.domainNameErrorArray.push(domainValuesObject);
    }
  }

  checkIfExist(item: any) {
    let index = this.domainNameErrorArray.findIndex(object => object.item === item);
    return index === -1 ? true : false;
  }

  openUserDeleteModal(user : User) {
    this.showDeleteUserPopup = true;
    this.userToOperateOn = user;
  }
  openUserEditModal(userObj: any) {
    this.isEditUser = true;
    this.addUserPopupFlag = true;
    this.groupSelectedList = [];
    this.newUserForm.controls['firstName'].setValue(userObj.firstName);
    this.newUserForm.controls['lastName'].setValue(userObj.lastName);
    this.newUserForm.controls['email'].setValue(userObj.email);
    this.userId = userObj.id;

    if (userObj.groups.length > 0) {
      userObj.groups.map((group: any) => {
        this.groupSelectedList.push(group.id);
      });
    }

  }
  isGroupSelected(groupObj: any) {
    return this.groupSelectedList.indexOf(groupObj.id) != -1;
  }

  saveUser() {
    this.userSubmitted = true;
    if (this.newUserForm.valid) {
      const userData = this.newUserForm.getRawValue();
      userData['groups'] = this.groupSelectedList;
      userData['id'] = this.userId;
      this.userListService.updateUser(userData).subscribe((response: any) => {
        if (response.status == 1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Informacje o użytkowniku ".concat(userData.firstName, " ", userData.lastName, " zostały zmienione"));
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Informacje o użytkowniku ".concat(userData.firstName, " ", userData.lastName, " nie zostały zmienione. Spróbuj jeszcze raz"));

        // this.addUserPopupFlag = false;
        // this.userSubmitted = false;

        this.hidePopup();

        if (!this.usersAreFiltered)
          this.iterate(this.currentPage);
        else
          this.getFilteredUserList(true);

        },
        (error: any) => {
          console.log("Error:", error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Informacje o użytkowniku ".concat(userData.firstName, " ", userData.lastName, "nie zostały zmienione. Spróbuj jeszcze raz"));
        }
      );
    }
  }
  openFilterPopup() {
    this.filter = true;
    this.getDictionaries();
  }

  clearForm() {
    this.usersAreFiltered = false;
    this.iterate(this.currentPage);

    this.userGroupsForFilterSelected = [];
    this.userDomainsForFilterSelected = [];
    this.userNotificationFrequenciesForFilterSelected = [];
    this.interestAreasForFilterSelected = [];
    this.userAreasForFilterSelected = [];
    this.userPositionsForFilterSelected = [];
    this.interestClientGroupsForFilterSeleted = [];
    this.interestInstitutionsForFilterSelected = [];
    this.interestProductsForFilterSelected = [];
    this.userActiveStatusSelected = [];
    this.userBlockStatusSelected = [];
    this.filter = false;
    this.filteredUsersCount = 0;
    this.filterObj = {};
    this.dateFrom = null;
    this.dateTo = null;
    this.dateFromFilter = null;
    this.dateToFilter =null;
  }

  orderByClick(orderByField : string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }

    if (!this.usersAreFiltered)
      this.getUsers(this.currentPage);
    else
      this.getFilteredUserList(true);
  }

  private createSortString() : string {
    let sortString = '';
    if (this.orderAsc)
      sortString = this.orderByField.concat(" ASC");
    else
      sortString = this.orderByField.concat(" DESC");

    return sortString;
  }

  private getUsers(goOnPage? : number) : void {
    this.userListService.getUsers({sortString : this.createSortString()}).subscribe(
      res => {
        if (res.status ==='ok') {
          this.userData = res["record"];
          if (goOnPage > 1)
            this.setPage(goOnPage);
          else
            this.setPage(1);
        } else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie pobrano listy użytkowników");
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie pobrano listy użytkowników");
      }
    );
  }

  private showFilteredUserList() {
    this.usersAreFiltered = true;
    this.getFilteredUserList(true);
    this.filter = false;
    this.selectedUserIds = [];
    this.selectedUsers = [];
    this.headerChecked = false;
  }

  private getFilteredUserList(returnResult : boolean) : void {
    let filterSetting = {};

    if (this.userActiveStatusSelected.length === 1) {
      if (this.userActiveStatusSelected[0] === 'Aktywowany')
        filterSetting['activeFilter'] = true;
      else
        filterSetting['activeFilter'] = false;
    }

    if (this.userBlockStatusSelected.length === 1) {
      if (this.userBlockStatusSelected[0] === 'Zablokowany')
        filterSetting['blockedFilter'] = true;
      else
        filterSetting['blockedFilter'] = false;
    }

    if (this.userTypeSelected.length === 1) {
      if (this.userTypeSelected[0] === 'Administrator')
        filterSetting['isAdminFilter'] = true;
      else
        filterSetting['isAdminFilter'] = false;
    }

    if (this.marketingAgreementSelected.length === 1) {
      if (this.marketingAgreementSelected[0] === 'Zgoda marketingowa')
        filterSetting['marketingAgreementFilter'] = true;
      else
        filterSetting['marketingAgreementFilter'] = false;
    }

    if (this.userGroupsForFilterSelected.length > 0)
      filterSetting['groups'] = this.userGroupsForFilterSelected;

    if (this.userDomainsForFilterSelected.length > 0)
      filterSetting['domainFilter'] = this.userDomainsForFilterSelected;

    if (this.userNotificationFrequenciesForFilterSelected.length > 0)
      filterSetting['notifications'] = this.userNotificationFrequenciesForFilterSelected;

    if (this.userAreasForFilterSelected.length > 0)
      filterSetting['areaFilter'] = this.userAreasForFilterSelected;

    if (this.userPositionsForFilterSelected.length > 0)
      filterSetting['position'] = this.userPositionsForFilterSelected;

    if (this.interestAreasForFilterSelected.length > 0)
      filterSetting['interests_areas'] = this.interestAreasForFilterSelected;

    if (this.interestClientGroupsForFilterSeleted.length > 0)
      filterSetting['interests_client_groups'] = this.interestClientGroupsForFilterSeleted;

    if (this.interestInstitutionsForFilterSelected.length > 0)
      filterSetting['interests_institutions'] = this.interestInstitutionsForFilterSelected;

    if (this.interestProductsForFilterSelected.length > 0)
      filterSetting['interests_products'] = this.interestProductsForFilterSelected;

    //Todo: Jak przy jakimś zadaniu będzie czas uporządkować filterSettings i filterObject
    if (this.filterObj['dateFrom'])
      filterSetting['dateFrom'] = this.filterObj['dateFrom'];

    if (this.filterObj['dateTo'])
      filterSetting['dateTo'] = this.filterObj['dateTo'];

    filterSetting['sortString'] = this.createSortString();

    this.userListService.getUsers(filterSetting).subscribe(
        res => {
          if (res.status == 'ok') {
            this.filteredUsersCount = res.record.length;
            if (returnResult) {
              this.userData = res['record'];
              this.setPage(this.currentPage);
            }
          } else {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano listy użytkowników");
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano listy użytkowników")
        }
    );
  }

  private modifySelectedElementsForFilter(selectedElements  : Array<string>, element : string) {
    let position = selectedElements.indexOf(element);
    if (position === -1)
      selectedElements.push(element);
    else
      selectedElements.splice(position, 1);

    this.getFilteredUserList(false);
  }

  private modifySelectedElements(selectedElements  : Array<string>, element : string) {
    let position = selectedElements.indexOf(element);
    if (position === -1)
      selectedElements.push(element);
    else
      selectedElements.splice(position, 1);
  }

  private getDictionaries() {
    forkJoin(
      this.commonService.getNotificationFrequencyDictionary(),
      this.commonService.getAreaDictionary(),
      this.commonService.getPositionDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getProductsDictionary(),
      this.userListService.getListOfUniqueDomains(),
      this.userListService.getGroupList("name ASC"),
    ).subscribe(([notificationFrequencies, areas, positions, clientGroups, institutions, products, domains, groups]) => {
      this.notificationFrequencies = notificationFrequencies;
      this.areas = areas;
      this.positions = positions;
      this.clientGroups = clientGroups;
      this.institutions = institutions;
      this.products = products;
      this.userDomains = domains['record'];
      this.userGroups = groups['record'];
      },
      (error) => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano słowników");
        console.log("Wystąpił błąd! Nie pobrano słowników:", JSON.stringify(error));
      });
  }
}
